// Gerado: oikos-design inventory + rotas (telas/App)
const INVENTORY = [
  {
    "id": 1,
    "codigo": "CMP-001",
    "grupoId": "layout",
    "grupo": "Layout",
    "nome": "Footer",
    "arquivo": "components/HorizontalLayout/Footer.js",
    "kind": "morto",
    "usadoEm": [],
    "morto": true,
    "apareceEm": []
  },
  {
    "id": 2,
    "codigo": "CMP-002",
    "grupoId": "layout",
    "grupo": "Layout",
    "nome": "Header",
    "arquivo": "components/HorizontalLayout/Header.js",
    "kind": "shell",
    "usadoEm": [
      "components/HorizontalLayout/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "(quase todas as telas autenticadas)",
        "titulo": "Chrome do HorizontalLayout",
        "nota": "via Header/Navbar/Layout"
      }
    ]
  },
  {
    "id": 3,
    "codigo": "CMP-003",
    "grupoId": "layout",
    "grupo": "Layout",
    "nome": "Navbar",
    "arquivo": "components/HorizontalLayout/Navbar.js",
    "kind": "shell",
    "usadoEm": [
      "components/HorizontalLayout/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "(quase todas as telas autenticadas)",
        "titulo": "Chrome do HorizontalLayout",
        "nota": "via Header/Navbar/Layout"
      }
    ]
  },
  {
    "id": 4,
    "codigo": "CMP-004",
    "grupoId": "layout",
    "grupo": "Layout",
    "nome": "HorizontalLayout",
    "arquivo": "components/HorizontalLayout/index.js",
    "kind": "util",
    "usadoEm": [
      "App.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "(quase todas as telas autenticadas)",
        "titulo": "Chrome do HorizontalLayout",
        "nota": "via Header/Navbar/Layout"
      }
    ]
  },
  {
    "id": 5,
    "codigo": "CMP-005",
    "grupoId": "common",
    "grupo": "Common",
    "nome": "BackendSelector",
    "arquivo": "components/Common/BackendSelector.js",
    "kind": "live",
    "usadoEm": [
      "components/HorizontalLayout/Header.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "(quase todas as telas autenticadas)",
        "titulo": "Chrome do HorizontalLayout",
        "nota": "via Header/Navbar/Layout"
      }
    ]
  },
  {
    "id": 6,
    "codigo": "CMP-006",
    "grupoId": "common",
    "grupo": "Common",
    "nome": "Breadcrumb",
    "arquivo": "components/Common/Breadcrumb.js",
    "kind": "live",
    "usadoEm": [
      "components/Template/ProjectFinancialResume/ProjectFinancialResume.jsx",
      "pages/Admin/index.js",
      "pages/Admin/oficios.js",
      "pages/Agenda/UserAgenda/index.js",
      "pages/Approval/Resume/index.js",
      "pages/Budget/Dashboard/index.js",
      "pages/Comercial/Acompanhamento/Acompanhamento.jsx",
      "pages/Comercial/Contracts/Contract/index.js",
      "pages/Comercial/Contracts/DraftContract/index.js",
      "pages/Comercial/Contracts/index.js",
      "pages/Comercial/Private/Proposal/index.js",
      "pages/Comercial/Private/index.js",
      "pages/Comercial/Public/index.js",
      "pages/Dashboard/EPApprovement.js",
      "pages/Dashboard/ProductsApprovement.js",
      "pages/Dashboard/ProjectsLinks.js",
      "pages/Dashboard/index.js",
      "pages/Feedback/NewFeedback/index.js",
      "pages/Financial/Orcamento/index.js",
      "pages/Financial/Receitas/index.js",
      "pages/Financial/index.js",
      "pages/GestaoMinutas/index.js",
      "pages/HumanResources/ActivitiesReport/index.js",
      "pages/HumanResources/Dashboard/index.js",
      "pages/HumanResources/FichaPj/RhFichaPjList.jsx",
      "pages/HumanResources/FinishExpedient/index.js",
      "pages/HumanResources/RegisterAbsence/index.js",
      "pages/HumanResources/RetroactiveExpedient/index.js",
      "pages/HumanResources/VacationRequest/index.js",
      "pages/Management/LegalSolicitations/index.js",
      "pages/Management/OfficialLetters/index.js",
      "pages/Management/PendingSolicitations/index.js",
      "pages/Management/ReplySolicitation/index.js",
      "pages/Patrimony/AssetPurchaseAndMaintenance/index.js",
      "pages/Patrimony/TiSolicitations/index.js",
      "pages/Tasks/MyTasks/index.js",
      "pages/TeamsTranscripts/index.js",
      "pages/TechnicalDep/Payments/index.js",
      "pages/TechnicalDep/Products/index.js",
      "pages/TechnicalDep/Project/prefribeiraopreto/sig/index.js",
      "pages/User/MySolicitations/index.js",
      "pages/User/Profile/index.js",
      "pages/User/ReplySolicitation/index.js",
      "pages/Wallet/Resume/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/admin",
        "titulo": "Admin"
      },
      {
        "rota": "/agenda",
        "titulo": "Agenda"
      },
      {
        "rota": "/aprovacoes",
        "titulo": "Aprovações"
      },
      {
        "rota": "/carteira",
        "titulo": "Carteira"
      },
      {
        "rota": "/colaborador/solicitacoes",
        "titulo": "Minhas solicitações"
      },
      {
        "rota": "/colaborador/solicitacoes/:id",
        "titulo": "Responder solicitação"
      },
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/contratos/:id",
        "titulo": "Contrato"
      },
      {
        "rota": "/comercial/contratos/minuta/:id",
        "titulo": "Minuta de contrato"
      },
      {
        "rota": "/comercial/privado",
        "titulo": "Comercial privado"
      },
      {
        "rota": "/comercial/privado/propostas/:id",
        "titulo": "Proposta privada"
      },
      {
        "rota": "/comercial/publico",
        "titulo": "Comercial público"
      },
      {
        "rota": "/dashboard",
        "titulo": "Dashboard"
      },
      {
        "rota": "/dashboardfinancial",
        "titulo": "Dashboard financeiro"
      },
      {
        "rota": "/dep-tecnico/produtos",
        "titulo": "Produtos"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/dep-tecnico/projetos/prefribeiraopreto/sig",
        "titulo": "Pref. Ribeirão — SIG"
      },
      {
        "rota": "/dep-tecnico/solicitacao-pagamento",
        "titulo": "Solicitação de pagamento"
      },
      {
        "rota": "/feedback/novo",
        "titulo": "Novo feedback"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/gerencia/oficios",
        "titulo": "Ofícios"
      },
      {
        "rota": "/gerencia/solicitacao-juridica",
        "titulo": "Solicitação jurídica"
      },
      {
        "rota": "/gerencia/solicitacoes",
        "titulo": "Solicitações gerência"
      },
      {
        "rota": "/gerencia/solicitacoes/:id",
        "titulo": "Responder solicitação (gerência)"
      },
      {
        "rota": "/gestao-de-minutas",
        "titulo": "Gestão de minutas"
      },
      {
        "rota": "/minhas-transcricoes",
        "titulo": "Transcrições Teams"
      },
      {
        "rota": "/orcamento",
        "titulo": "Orçamento"
      },
      {
        "rota": "/patrimonio/aquisicao-e-manutencao",
        "titulo": "Aquisição e manutenção"
      },
      {
        "rota": "/patrimonio/chamados-de-ti",
        "titulo": "Chamados de TI"
      },
      {
        "rota": "/perfil",
        "titulo": "Perfil"
      },
      {
        "rota": "/receitas",
        "titulo": "Receitas"
      },
      {
        "rota": "/recursos-humanos/dashboard",
        "titulo": "RH Dashboard"
      },
      {
        "rota": "/recursos-humanos/dashboard/fichas-pj",
        "titulo": "Fichas PJ (lista, via dashboard)"
      },
      {
        "rota": "/recursos-humanos/encerrar-expediente",
        "titulo": "Encerrar expediente"
      },
      {
        "rota": "/recursos-humanos/ficha-pj",
        "titulo": "Ficha PJ (sem chrome do layout)"
      },
      {
        "rota": "/recursos-humanos/fichas-pj",
        "titulo": "Fichas PJ"
      },
      {
        "rota": "/recursos-humanos/justificativa-de-ausencia",
        "titulo": "Ausência"
      },
      {
        "rota": "/recursos-humanos/ponto-retroativo",
        "titulo": "Ponto retroativo"
      },
      {
        "rota": "/recursos-humanos/relatorio-de-atividades",
        "titulo": "Relatório de atividades"
      },
      {
        "rota": "/recursos-humanos/solicitacao-de-ferias",
        "titulo": "Férias"
      },
      {
        "rota": "/tarefas",
        "titulo": "Minhas tarefas"
      }
    ]
  },
  {
    "id": 7,
    "codigo": "CMP-007",
    "grupoId": "common",
    "grupo": "Common",
    "nome": "ExpedientBtn",
    "arquivo": "components/Common/ExpedientBtn.js",
    "kind": "live",
    "usadoEm": [
      "components/HorizontalLayout/Header.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "(quase todas as telas autenticadas)",
        "titulo": "Chrome do HorizontalLayout",
        "nota": "via Header/Navbar/Layout"
      }
    ]
  },
  {
    "id": 8,
    "codigo": "CMP-008",
    "grupoId": "common",
    "grupo": "Common",
    "nome": "NotificationDropdown",
    "arquivo": "components/Common/NotificationDropdown.js",
    "kind": "live",
    "usadoEm": [
      "components/HorizontalLayout/Header.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "(quase todas as telas autenticadas)",
        "titulo": "Chrome do HorizontalLayout",
        "nota": "via Header/Navbar/Layout"
      }
    ]
  },
  {
    "id": 9,
    "codigo": "CMP-009",
    "grupoId": "common",
    "grupo": "Common",
    "nome": "PdfReader",
    "arquivo": "components/Common/PdfReader.js",
    "kind": "live",
    "usadoEm": [
      "components/Modal/PdfView.js",
      "pages/Management/ReplySolicitation/index.js",
      "pages/User/ReplySolicitation/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/colaborador/solicitacoes/:id",
        "titulo": "Responder solicitação"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/gerencia/solicitacoes/:id",
        "titulo": "Responder solicitação (gerência)"
      },
      {
        "rota": "/task",
        "titulo": "Aprovações (tasks)"
      }
    ]
  },
  {
    "id": 10,
    "codigo": "CMP-010",
    "grupoId": "common",
    "grupo": "Common",
    "nome": "ProfileMenu",
    "arquivo": "components/Common/ProfileMenu.js",
    "kind": "live",
    "usadoEm": [
      "components/HorizontalLayout/Header.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "(quase todas as telas autenticadas)",
        "titulo": "Chrome do HorizontalLayout",
        "nota": "via Header/Navbar/Layout"
      }
    ]
  },
  {
    "id": 11,
    "codigo": "CMP-011",
    "grupoId": "template-input",
    "grupo": "Template — Input",
    "nome": "AsyncCreatableSelect",
    "arquivo": "components/Template/Input/AsyncCreatableSelect.js",
    "kind": "live",
    "usadoEm": [
      "components/Modal/AddDraftContract.js",
      "components/Modal/NewLegalEntity.js",
      "components/Modal/ViewDraftApproval.js",
      "components/Template/Tab/StakeProj.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/privado",
        "titulo": "Comercial privado"
      },
      {
        "rota": "/comercial/publico",
        "titulo": "Comercial público"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 12,
    "codigo": "CMP-012",
    "grupoId": "template-input",
    "grupo": "Template — Input",
    "nome": "AsyncSelect",
    "arquivo": "components/Template/Input/AsyncSelect.js",
    "kind": "live",
    "usadoEm": [
      "components/Modal/AddContract.js",
      "components/Modal/AddContract2.jsx",
      "components/Modal/AddDraftContract.js",
      "components/Modal/NewLegalEntity.js",
      "components/Modal/ViewDraftApproval.js",
      "components/Template/Files/AddContractFiles.js",
      "components/Template/Files/AddFiles.js",
      "components/Template/Files/AddFilesNoForm.js",
      "components/Template/Tab/StakeProj.js",
      "pages/Admin/activities.js",
      "pages/Admin/departments.js",
      "pages/Admin/sectors.js",
      "pages/Admin/services.js",
      "pages/TechnicalDep/Projects/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/admin",
        "titulo": "Admin"
      },
      {
        "rota": "/bordero",
        "titulo": "Borderô"
      },
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/contratos/:id",
        "titulo": "Contrato"
      },
      {
        "rota": "/comercial/privado",
        "titulo": "Comercial privado"
      },
      {
        "rota": "/comercial/publico",
        "titulo": "Comercial público"
      },
      {
        "rota": "/contratacoes",
        "titulo": "Contratações"
      },
      {
        "rota": "/dashboardfinancial",
        "titulo": "Dashboard financeiro"
      },
      {
        "rota": "/dep-tecnico/projetos",
        "titulo": "Projetos"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/dep-tecnico/solicitacao-pagamento",
        "titulo": "Solicitação de pagamento"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      },
      {
        "rota": "/task",
        "titulo": "Aprovações (tasks)"
      }
    ]
  },
  {
    "id": 13,
    "codigo": "CMP-013",
    "grupoId": "template-input",
    "grupo": "Template — Input",
    "nome": "DBSwitch",
    "arquivo": "components/Template/Input/DBSwitch.js",
    "kind": "live",
    "usadoEm": [
      "pages/CardInfoProdutoAntigo/CardInfoProdutoAntigo.jsx",
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 14,
    "codigo": "CMP-014",
    "grupoId": "template-input",
    "grupo": "Template — Input",
    "nome": "MaskedInput",
    "arquivo": "components/Template/Input/MaskedInput.js",
    "kind": "live",
    "usadoEm": [
      "components/Modal/AddContract.js",
      "components/Modal/AddContract2.jsx",
      "components/Modal/AddDraftContract.js",
      "components/Modal/NewLegalEntity.js",
      "components/Modal/ViewDraftApproval.js",
      "components/Modals/ModalContrFornInfo/ModalContrFornInfo.jsx",
      "components/Modals/ModalFormAddPjOuPf/ModalFormAddPjOuPf.jsx",
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx",
      "components/Modals/ModalFormContrFornEventos/ModalFormContrFornEventos.jsx",
      "components/Modals/ModalFormDocumentos/ModalFormDocumentos.jsx",
      "components/Modals/ModalFormEditFornecedor/ModalFormEditFornecedor.jsx",
      "components/Modals/ModalFormulario/ModalFormulario.jsx",
      "components/Modals/ModalFormularioSecundario/ModalFormularioSecundario.jsx",
      "components/Modals/ModalPedidoCompra/ModalPedidoCompra.jsx",
      "components/Modals/ModalPedidoCotacao/CotacaoRapidaPropostasSection.jsx",
      "components/Modals/ModalPedidoCotacao/IndicacaoCotacaoRapidaForm.jsx",
      "components/Modals/ModalPedidoCotacao/ModalPedidoCotacao.jsx",
      "components/Template/Doc/PedidosCompraListTable.js",
      "components/Template/Doc/Prod.js",
      "components/Template/Tab/StakeProj.js",
      "pages/Admin/activities.js",
      "pages/Admin/departments.js",
      "pages/Admin/documents.js",
      "pages/Admin/legalPerson.js",
      "pages/Admin/physicalPerson.js",
      "pages/Admin/sectors.js",
      "pages/Admin/services.js",
      "pages/Approval/Resume/index.js",
      "pages/CardInfoProdutoAntigo/CardInfoProdutoAntigo.jsx",
      "pages/Comercial/Acompanhamento/NovaPropostaEmBranco.jsx",
      "pages/Comercial/Acompanhamento/RevisarOrcamento.jsx",
      "pages/Customer/index.js",
      "pages/Financial/Bordero/DadosContaAPagar.js",
      "pages/Financial/Bordero/ModalAddContaAPagar.js",
      "pages/Financial/Bordero/ModalEdicaoContaAPagar.js",
      "pages/Financial/Bordero/contasAPagar.js",
      "pages/Financial/Contratacoes/index.js",
      "pages/Management/ReplySolicitation/index.js",
      "pages/Orcamentacao/Orcamentacao.jsx",
      "pages/Patrimony/AssetPurchaseAndMaintenance/index.js",
      "pages/TechnicalDep/Payments/index.js",
      "pages/TechnicalDep/Project/Activities/index.js",
      "pages/TechnicalDep/Project/index.js",
      "pages/User/Profile/index.js",
      "pages/User/ReplySolicitation/index.js",
      "pages/Wallet/Resume/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/admin",
        "titulo": "Admin"
      },
      {
        "rota": "/aprovacoes",
        "titulo": "Aprovações"
      },
      {
        "rota": "/bordero",
        "titulo": "Borderô"
      },
      {
        "rota": "/carteira",
        "titulo": "Carteira"
      },
      {
        "rota": "/cliente/projeto/:id",
        "titulo": "Cliente — projeto"
      },
      {
        "rota": "/colaborador/solicitacoes/:id",
        "titulo": "Responder solicitação"
      },
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/nova-proposta-em-branco/:id",
        "titulo": "Nova proposta em branco"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/contratos/:id",
        "titulo": "Contrato"
      },
      {
        "rota": "/comercial/orcamentacao",
        "titulo": "Orçamentação"
      },
      {
        "rota": "/comercial/pesquisadesatisfacao",
        "titulo": "Pesquisa de satisfação"
      },
      {
        "rota": "/comercial/privado",
        "titulo": "Comercial privado"
      },
      {
        "rota": "/comercial/publico",
        "titulo": "Comercial público"
      },
      {
        "rota": "/contratacoes",
        "titulo": "Contratações"
      },
      {
        "rota": "/dashboardfinancial",
        "titulo": "Dashboard financeiro"
      },
      {
        "rota": "/dep-tecnico/projetos",
        "titulo": "Projetos"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/dep-tecnico/solicitacao-pagamento",
        "titulo": "Solicitação de pagamento"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/gerencia/solicitacoes/:id",
        "titulo": "Responder solicitação (gerência)"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      },
      {
        "rota": "/patrimonio/aquisicao-e-manutencao",
        "titulo": "Aquisição e manutenção"
      },
      {
        "rota": "/perfil",
        "titulo": "Perfil"
      }
    ]
  },
  {
    "id": 15,
    "codigo": "CMP-015",
    "grupoId": "template-input",
    "grupo": "Template — Input",
    "nome": "Select",
    "arquivo": "components/Template/Input/Select.js",
    "kind": "live",
    "usadoEm": [
      "components/GridProductsCalendar/GridProductsCalendar.jsx",
      "components/Modal/AddContract.js",
      "components/Modal/AddDraftContract.js",
      "components/Modal/NewLegalEntity.js",
      "components/Modal/ViewDraftApproval.js",
      "components/Modals/ModalContrFornInfo/ModalContrFornInfo.jsx",
      "components/Modals/ModalFormAddFavBordero/ModalFormAddFavBordero.jsx",
      "components/Modals/ModalFormAddFornecedor/ModalFormAddFornecedor.jsx",
      "components/Modals/ModalFormAddPjOuPf/ModalFormAddPjOuPf.jsx",
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx",
      "components/Modals/ModalFormContrFornEventos/ModalFormContrFornEventos.jsx",
      "components/Modals/ModalFormDisparoEmails/DisparoEmailsCotacaoForm.jsx",
      "components/Modals/ModalFormDocumentos/ModalFormDocumentos.jsx",
      "components/Modals/ModalFormEdicaoFavBordero/ModalFormEdicaoFavBordero.jsx",
      "components/Modals/ModalFormEditFornecedor/ModalFormEditFornecedor.jsx",
      "components/Modals/ModalFormEntregueAoCliente/ModalFormEntregueAoCliente.jsx",
      "components/Modals/ModalFormOrcItem/ModalFormOrcItem.jsx",
      "components/Modals/ModalFormulario/ModalFormulario.jsx",
      "components/Modals/ModalFormularioSecundario/ModalFormularioSecundario.jsx",
      "components/Modals/ModalPedidoCompra/ModalPedidoCompra.jsx",
      "components/Modals/ModalPedidoCotacao/ModalPedidoCotacao.jsx",
      "components/Template/Doc/EquiProj.js",
      "components/Template/Doc/OrcItemsProj.js",
      "components/Template/Doc/PedidosCompraListTable.js",
      "components/Template/Doc/Prod.js",
      "components/Template/Doc/Vagas.js",
      "components/Template/Doc/projFin.js",
      "components/Template/Tab/StakeProj.js",
      "components/TesteOneDrive/TesteOneDrive.jsx",
      "pages/Admin/documents.js",
      "pages/Admin/legalPerson.js",
      "pages/Admin/oficios.js",
      "pages/Admin/physicalPerson.js",
      "pages/Admin/project.js",
      "pages/Approval/Resume/index.js",
      "pages/CardInfoProdutoAntigo/CardInfoProdutoAntigo.jsx",
      "pages/Comercial/Acompanhamento/Acompanhamento.jsx",
      "pages/Comercial/Acompanhamento/NovaPropostaEmBranco.jsx",
      "pages/Comercial/Acompanhamento/RevisarOrcamento.jsx",
      "pages/Comercial/Contracts/index.js",
      "pages/Comercial/Private/Proposal/index.js",
      "pages/Comercial/Private/index.js",
      "pages/Comercial/Public/index.js",
      "pages/Customer/index.js",
      "pages/Dashboard/ActivitiesGraph.js",
      "pages/Dashboard/EPApprovement.js",
      "pages/Dashboard/ProductsApprovement.js",
      "pages/Dashboard/ProjectsLinks.js",
      "pages/Feedback/NewFeedback/index.js",
      "pages/Financial/ActivitiesGraph.js",
      "pages/Financial/Bordero/contasAPagar.js",
      "pages/Financial/IncomeGraph.js",
      "pages/Financial/Receitas/index.js",
      "pages/Financial/index.js",
      "pages/HumanResources/ActivitiesReport/index.js",
      "pages/HumanResources/FinishExpedient/index.js",
      "pages/Management/LegalSolicitations/index.js",
      "pages/Management/OfficialLetters/index.js",
      "pages/Management/PendingSolicitations/index.js",
      "pages/Orcamentacao/Orcamentacao.jsx",
      "pages/Patrimony/AssetPurchaseAndMaintenance/index.js",
      "pages/Patrimony/TiSolicitations/index.js",
      "pages/Task/index.js",
      "pages/TechnicalDep/Payments/index.js",
      "pages/TechnicalDep/Products/DashboardProdutos.jsx",
      "pages/TechnicalDep/Products/index.js",
      "pages/TechnicalDep/Project/Activities/index.js",
      "pages/TechnicalDep/Project/components/MarketingCaseForm.jsx",
      "pages/TechnicalDep/Project/index.js",
      "pages/TechnicalDep/Projects/index.js",
      "pages/User/MySolicitations/index.js",
      "pages/User/Profile/index.js",
      "pages/Wallet/Resume/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/admin",
        "titulo": "Admin"
      },
      {
        "rota": "/aprovacoes",
        "titulo": "Aprovações"
      },
      {
        "rota": "/bordero",
        "titulo": "Borderô"
      },
      {
        "rota": "/carteira",
        "titulo": "Carteira"
      },
      {
        "rota": "/cliente/projeto/:id",
        "titulo": "Cliente — projeto"
      },
      {
        "rota": "/colaborador/solicitacoes",
        "titulo": "Minhas solicitações"
      },
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/nova-proposta-em-branco/:id",
        "titulo": "Nova proposta em branco"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/orcamentacao",
        "titulo": "Orçamentação"
      },
      {
        "rota": "/comercial/pesquisadesatisfacao",
        "titulo": "Pesquisa de satisfação"
      },
      {
        "rota": "/comercial/privado",
        "titulo": "Comercial privado"
      },
      {
        "rota": "/comercial/privado/propostas/:id",
        "titulo": "Proposta privada"
      },
      {
        "rota": "/comercial/publico",
        "titulo": "Comercial público"
      },
      {
        "rota": "/dashboard",
        "titulo": "Dashboard"
      },
      {
        "rota": "/dashboardfinancial",
        "titulo": "Dashboard financeiro"
      },
      {
        "rota": "/dep-tecnico/produtos",
        "titulo": "Produtos"
      },
      {
        "rota": "/dep-tecnico/projetos",
        "titulo": "Projetos"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/dep-tecnico/solicitacao-pagamento",
        "titulo": "Solicitação de pagamento"
      },
      {
        "rota": "/feedback/novo",
        "titulo": "Novo feedback"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/gerencia/oficios",
        "titulo": "Ofícios"
      },
      {
        "rota": "/gerencia/solicitacao-juridica",
        "titulo": "Solicitação jurídica"
      },
      {
        "rota": "/gerencia/solicitacoes",
        "titulo": "Solicitações gerência"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      },
      {
        "rota": "/patrimonio/aquisicao-e-manutencao",
        "titulo": "Aquisição e manutenção"
      },
      {
        "rota": "/patrimonio/chamados-de-ti",
        "titulo": "Chamados de TI"
      },
      {
        "rota": "/perfil",
        "titulo": "Perfil"
      },
      {
        "rota": "/receitas",
        "titulo": "Receitas"
      },
      {
        "rota": "/recursos-humanos/encerrar-expediente",
        "titulo": "Encerrar expediente"
      },
      {
        "rota": "/recursos-humanos/relatorio-de-atividades",
        "titulo": "Relatório de atividades"
      },
      {
        "rota": "/task",
        "titulo": "Aprovações (tasks)"
      }
    ]
  },
  {
    "id": 16,
    "codigo": "CMP-016",
    "grupoId": "template-table",
    "grupo": "Template — Table",
    "nome": "DBTable",
    "arquivo": "components/Template/Table/DBTable.js",
    "kind": "live",
    "usadoEm": [
      "pages/Financial/Orcamento/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dashboardfinancial",
        "titulo": "Dashboard financeiro"
      },
      {
        "rota": "/orcamento",
        "titulo": "Orçamento"
      }
    ]
  },
  {
    "id": 17,
    "codigo": "CMP-017",
    "grupoId": "template-table",
    "grupo": "Template — Table",
    "nome": "DataTable",
    "arquivo": "components/Template/Table/DataTable.js",
    "kind": "live",
    "usadoEm": [
      "components/Template/Doc/EquiProj.js",
      "components/Template/Doc/Vagas.js",
      "components/Template/Doc/projFin.js",
      "components/Template/Tab/StakeProj.js",
      "pages/Admin/activities.js",
      "pages/Admin/departments.js",
      "pages/Admin/documents.js",
      "pages/Admin/labs.js",
      "pages/Admin/legalPerson.js",
      "pages/Admin/oficios.js",
      "pages/Admin/physicalPerson.js",
      "pages/Admin/project.js",
      "pages/Admin/sectors.js",
      "pages/Admin/services.js",
      "pages/Approval/Resume/index.js",
      "pages/Comercial/Acompanhamento/Acompanhamento.jsx",
      "pages/Comercial/Contracts/index.js",
      "pages/Comercial/Private/Proposal/index.js",
      "pages/Comercial/Private/index.js",
      "pages/Comercial/Public/index.js",
      "pages/Financial/Bordero/contasAPagar.js",
      "pages/Financial/Orcamento/index.js",
      "pages/Management/LegalSolicitations/index.js",
      "pages/Management/OfficialLetters/index.js",
      "pages/Management/PendingSolicitations/index.js",
      "pages/Patrimony/AssetPurchaseAndMaintenance/index.js",
      "pages/Patrimony/TiSolicitations/index.js",
      "pages/TechnicalDep/Project/index.js",
      "pages/TechnicalDep/Projects/index.js",
      "pages/User/MySolicitations/index.js",
      "pages/Wallet/Resume/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/admin",
        "titulo": "Admin"
      },
      {
        "rota": "/aprovacoes",
        "titulo": "Aprovações"
      },
      {
        "rota": "/bordero",
        "titulo": "Borderô"
      },
      {
        "rota": "/carteira",
        "titulo": "Carteira"
      },
      {
        "rota": "/colaborador/solicitacoes",
        "titulo": "Minhas solicitações"
      },
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/privado",
        "titulo": "Comercial privado"
      },
      {
        "rota": "/comercial/privado/propostas/:id",
        "titulo": "Proposta privada"
      },
      {
        "rota": "/comercial/publico",
        "titulo": "Comercial público"
      },
      {
        "rota": "/dashboardfinancial",
        "titulo": "Dashboard financeiro"
      },
      {
        "rota": "/dep-tecnico/projetos",
        "titulo": "Projetos"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/gerencia/oficios",
        "titulo": "Ofícios"
      },
      {
        "rota": "/gerencia/solicitacao-juridica",
        "titulo": "Solicitação jurídica"
      },
      {
        "rota": "/gerencia/solicitacoes",
        "titulo": "Solicitações gerência"
      },
      {
        "rota": "/orcamento",
        "titulo": "Orçamento"
      },
      {
        "rota": "/patrimonio/aquisicao-e-manutencao",
        "titulo": "Aquisição e manutenção"
      },
      {
        "rota": "/patrimonio/chamados-de-ti",
        "titulo": "Chamados de TI"
      }
    ]
  },
  {
    "id": 18,
    "codigo": "CMP-018",
    "grupoId": "template-table",
    "grupo": "Template — Table",
    "nome": "DualHorizontalScroll",
    "arquivo": "components/Template/Table/DualHorizontalScroll.jsx",
    "kind": "live",
    "usadoEm": [
      "pages/Management/LegalSolicitations/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/gerencia/solicitacao-juridica",
        "titulo": "Solicitação jurídica"
      }
    ]
  },
  {
    "id": 19,
    "codigo": "CMP-019",
    "grupoId": "template-table",
    "grupo": "Template — Table",
    "nome": "Pqgrid",
    "arquivo": "components/Template/Table/Pqgrid.js",
    "kind": "live",
    "usadoEm": [
      "components/Modal/AddContract.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/privado",
        "titulo": "Comercial privado"
      },
      {
        "rota": "/comercial/publico",
        "titulo": "Comercial público"
      }
    ]
  },
  {
    "id": 20,
    "codigo": "CMP-020",
    "grupoId": "template-files",
    "grupo": "Template — Files",
    "nome": "AddContractFiles",
    "arquivo": "components/Template/Files/AddContractFiles.js",
    "kind": "live",
    "usadoEm": [
      "components/Modal/AddContract.js",
      "components/Modal/AddDraftContract.js",
      "components/Modal/ViewDraftApproval.js",
      "pages/CardInfoProdutoAntigo/CardInfoProdutoAntigo.jsx",
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/privado",
        "titulo": "Comercial privado"
      },
      {
        "rota": "/comercial/publico",
        "titulo": "Comercial público"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 21,
    "codigo": "CMP-021",
    "grupoId": "template-files",
    "grupo": "Template — Files",
    "nome": "AddFiles",
    "arquivo": "components/Template/Files/AddFiles.js",
    "kind": "live",
    "usadoEm": [
      "components/Modal/AddContract.js",
      "components/Modal/AddContract2.jsx",
      "components/Modal/AddDraftContract.js",
      "components/Modal/ViewDraftApproval.js",
      "components/Modals/ModalFormContrFornEventos/ModalFormContrFornEventos.jsx",
      "components/Modals/ModalPedidoCompra/ModalPedidoCompra.jsx",
      "components/Template/Doc/DocTab.js",
      "pages/Admin/oficios.js",
      "pages/CardInfoProdutoAntigo/CardInfoProdutoAntigo.jsx",
      "pages/Comercial/Contracts/Contract/index.js",
      "pages/MeusFornecedores/ContratosTab.jsx",
      "pages/Task/index.js",
      "pages/TechnicalDep/Payments/index.js",
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/admin",
        "titulo": "Admin"
      },
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/contratos/:id",
        "titulo": "Contrato"
      },
      {
        "rota": "/comercial/privado",
        "titulo": "Comercial privado"
      },
      {
        "rota": "/comercial/publico",
        "titulo": "Comercial público"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/dep-tecnico/solicitacao-pagamento",
        "titulo": "Solicitação de pagamento"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      },
      {
        "rota": "/task",
        "titulo": "Aprovações (tasks)"
      }
    ]
  },
  {
    "id": 22,
    "codigo": "CMP-022",
    "grupoId": "template-files",
    "grupo": "Template — Files",
    "nome": "AddFilesNoForm",
    "arquivo": "components/Template/Files/AddFilesNoForm.js",
    "kind": "live",
    "usadoEm": [
      "components/Modal/AddContract2.jsx",
      "components/Modals/ModalContrFornInfo/ModalContrFornInfo.jsx",
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx",
      "pages/Financial/Bordero/ModalAddContaAPagar.js",
      "pages/Financial/Bordero/ModalEdicaoContaAPagar.js",
      "pages/Financial/Bordero/index.js",
      "pages/Financial/Contratacoes/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/bordero",
        "titulo": "Borderô"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/contratos/:id",
        "titulo": "Contrato"
      },
      {
        "rota": "/contratacoes",
        "titulo": "Contratações"
      },
      {
        "rota": "/dashboardfinancial",
        "titulo": "Dashboard financeiro"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 23,
    "codigo": "CMP-023",
    "grupoId": "template-files",
    "grupo": "Template — Files",
    "nome": "CompactAddFiles",
    "arquivo": "components/Template/Files/CompactAddFiles.js",
    "kind": "live",
    "usadoEm": [
      "components/Modals/ModalPedidoCotacao/CotacaoRapidaPropostasSection.jsx",
      "components/Template/Doc/PedidosCompraListTable.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 24,
    "codigo": "CMP-024",
    "grupoId": "template-doc",
    "grupo": "Template — Doc",
    "nome": "CompraCotacoesSemPedidoListTable",
    "arquivo": "components/Template/Doc/CompraCotacoesSemPedidoListTable.js",
    "kind": "morto",
    "usadoEm": [],
    "morto": true,
    "apareceEm": []
  },
  {
    "id": 25,
    "codigo": "CMP-025",
    "grupoId": "template-doc",
    "grupo": "Template — Doc",
    "nome": "DocTab",
    "arquivo": "components/Template/Doc/DocTab.js",
    "kind": "live",
    "usadoEm": [
      "pages/CardInfoProdutoAntigo/CardInfoProdutoAntigo.jsx",
      "pages/Task/index.js",
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/task",
        "titulo": "Aprovações (tasks)"
      }
    ]
  },
  {
    "id": 26,
    "codigo": "CMP-026",
    "grupoId": "template-doc",
    "grupo": "Template — Doc",
    "nome": "EquiProj",
    "arquivo": "components/Template/Doc/EquiProj.js",
    "kind": "live",
    "usadoEm": [
      "pages/CardInfoProdutoAntigo/CardInfoProdutoAntigo.jsx",
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 27,
    "codigo": "CMP-027",
    "grupoId": "template-doc",
    "grupo": "Template — Doc",
    "nome": "EvePag",
    "arquivo": "components/Template/Doc/EvePag.js",
    "kind": "live",
    "usadoEm": [
      "pages/CardInfoProdutoAntigo/CardInfoProdutoAntigo.jsx",
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 28,
    "codigo": "CMP-028",
    "grupoId": "template-doc",
    "grupo": "Template — Doc",
    "nome": "Extrato",
    "arquivo": "components/Template/Doc/Extrato.js",
    "kind": "live",
    "usadoEm": [
      "pages/Financial/FinancialResultGraph.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dashboardfinancial",
        "titulo": "Dashboard financeiro"
      }
    ]
  },
  {
    "id": 29,
    "codigo": "CMP-029",
    "grupoId": "template-doc",
    "grupo": "Template — Doc",
    "nome": "ModalLiberacaoFaturamentoRec",
    "arquivo": "components/Template/Doc/ModalLiberacaoFaturamentoRec.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Modals/ModalFormAprovacaoDoCliente/ModalFormAprovacaoDoCliente.jsx",
      "components/Modals/ModalFormAutorizarFaturamento/ModalFormAutorizarFaturamento.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 30,
    "codigo": "CMP-030",
    "grupoId": "template-doc",
    "grupo": "Template — Doc",
    "nome": "OrcItemsProj",
    "arquivo": "components/Template/Doc/OrcItemsProj.js",
    "kind": "live",
    "usadoEm": [
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 31,
    "codigo": "CMP-031",
    "grupoId": "template-doc",
    "grupo": "Template — Doc",
    "nome": "PedidosCompraListTable",
    "arquivo": "components/Template/Doc/PedidosCompraListTable.js",
    "kind": "live",
    "usadoEm": [
      "components/Template/Doc/OrcItemsProj.js",
      "pages/MeusFornecedores/CotacoesTab.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 32,
    "codigo": "CMP-032",
    "grupoId": "template-doc",
    "grupo": "Template — Doc",
    "nome": "Prod",
    "arquivo": "components/Template/Doc/Prod.js",
    "kind": "live",
    "usadoEm": [
      "pages/CardInfoProdutoAntigo/CardInfoProdutoAntigo.jsx",
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 33,
    "codigo": "CMP-033",
    "grupoId": "template-doc",
    "grupo": "Template — Doc",
    "nome": "Vagas",
    "arquivo": "components/Template/Doc/Vagas.js",
    "kind": "live",
    "usadoEm": [
      "components/Template/Doc/EquiProj.js",
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 34,
    "codigo": "CMP-034",
    "grupoId": "template-doc",
    "grupo": "Template — Doc",
    "nome": "compraCotacaoTableUtils",
    "arquivo": "components/Template/Doc/compraCotacaoTableUtils.js",
    "kind": "util",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx",
      "components/Modals/ModalPedidoCompra/ModalPedidoCompra.jsx",
      "components/Modals/ModalPedidoCotacao/ModalPedidoCotacao.jsx",
      "components/Template/Doc/CompraCotacoesSemPedidoListTable.js",
      "components/Template/Doc/OrcItemsProj.js",
      "components/Template/Doc/PedidosCompraListTable.js",
      "pages/MeusFornecedores/CotacoesTab.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 35,
    "codigo": "CMP-035",
    "grupoId": "template-doc",
    "grupo": "Template — Doc",
    "nome": "orcResumoOrcamentarioUtils",
    "arquivo": "components/Template/Doc/orcResumoOrcamentarioUtils.js",
    "kind": "util",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx",
      "components/Modals/ModalPedidoCompra/ModalPedidoCompra.jsx",
      "components/Modals/ModalPedidoCotacao/ModalPedidoCotacao.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 36,
    "codigo": "CMP-036",
    "grupoId": "template-doc",
    "grupo": "Template — Doc",
    "nome": "projFin",
    "arquivo": "components/Template/Doc/projFin.js",
    "kind": "morto",
    "usadoEm": [],
    "morto": true,
    "apareceEm": []
  },
  {
    "id": 37,
    "codigo": "CMP-037",
    "grupoId": "template-outros",
    "grupo": "Template — outros",
    "nome": "DayGrid",
    "arquivo": "components/Template/Calendar/DayGrid.js",
    "kind": "live",
    "usadoEm": [
      "pages/Tasks/MyTasks/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/tarefas",
        "titulo": "Minhas tarefas"
      }
    ]
  },
  {
    "id": 38,
    "codigo": "CMP-038",
    "grupoId": "template-outros",
    "grupo": "Template — outros",
    "nome": "TimeGrid",
    "arquivo": "components/Template/Calendar/TimeGrid.js",
    "kind": "live",
    "usadoEm": [
      "pages/Agenda/UserAgenda/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/agenda",
        "titulo": "Agenda"
      }
    ]
  },
  {
    "id": 39,
    "codigo": "CMP-039",
    "grupoId": "template-outros",
    "grupo": "Template — outros",
    "nome": "StepStatus",
    "arquivo": "components/Template/Progress/StepStatus.js",
    "kind": "live",
    "usadoEm": [
      "pages/CardInfoProdutoAntigo/CardInfoProdutoAntigo.jsx",
      "pages/Customer/index.js",
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/cliente/projeto/:id",
        "titulo": "Cliente — projeto"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 40,
    "codigo": "CMP-040",
    "grupoId": "template-outros",
    "grupo": "Template — outros",
    "nome": "ProjBordero",
    "arquivo": "components/Template/ProjBordero/ProjBordero.js",
    "kind": "morto",
    "usadoEm": [],
    "morto": true,
    "apareceEm": []
  },
  {
    "id": 41,
    "codigo": "CMP-041",
    "grupoId": "template-outros",
    "grupo": "Template — outros",
    "nome": "ProjectFinancialResume",
    "arquivo": "components/Template/ProjectFinancialResume/ProjectFinancialResume.jsx",
    "kind": "live",
    "usadoEm": [
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 42,
    "codigo": "CMP-042",
    "grupoId": "template-outros",
    "grupo": "Template — outros",
    "nome": "StakeProj",
    "arquivo": "components/Template/Tab/StakeProj.js",
    "kind": "live",
    "usadoEm": [
      "pages/CardInfoProdutoAntigo/CardInfoProdutoAntigo.jsx",
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 43,
    "codigo": "CMP-043",
    "grupoId": "template-outros",
    "grupo": "Template — outros",
    "nome": "FormInputTooltip",
    "arquivo": "components/Template/Tooltip/FormInputTooltip.js",
    "kind": "live",
    "usadoEm": [
      "components/Modal/AddContract.js",
      "components/Modal/AddContract2.jsx",
      "components/Modals/ModalFormContrForn/ContrFornValidationEntregaveis.jsx",
      "components/Modals/ModalPedidoCompra/ModalPedidoCompra.jsx",
      "components/Modals/ModalPedidoCotacao/CotacaoRapidaPropostasSection.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/contratos/:id",
        "titulo": "Contrato"
      },
      {
        "rota": "/comercial/privado",
        "titulo": "Comercial privado"
      },
      {
        "rota": "/comercial/publico",
        "titulo": "Comercial público"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 44,
    "codigo": "CMP-044",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalConfirmacao",
    "arquivo": "components/Modals/ModalConfirmacao/ModalConfirmacao.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Modal/AddContract2.jsx",
      "components/Modals/ModalContrFornInfo/ModalContrFornInfo.jsx",
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx",
      "components/Template/Doc/EquiProj.js",
      "components/Template/Doc/PedidosCompraListTable.js",
      "components/Template/Files/AddFilesNoForm.js",
      "components/Template/Tab/StakeProj.js",
      "pages/Comercial/Acompanhamento/RevisarOrcamento.jsx",
      "pages/Financial/Bordero/index.js",
      "pages/MeusFornecedores/ContratosTab.jsx",
      "pages/Orcamentacao/Orcamentacao.jsx",
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/bordero",
        "titulo": "Borderô"
      },
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/contratos/:id",
        "titulo": "Contrato"
      },
      {
        "rota": "/comercial/orcamentacao",
        "titulo": "Orçamentação"
      },
      {
        "rota": "/contratacoes",
        "titulo": "Contratações"
      },
      {
        "rota": "/dashboardfinancial",
        "titulo": "Dashboard financeiro"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 45,
    "codigo": "CMP-045",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalContrFornInfo",
    "arquivo": "components/Modals/ModalContrFornInfo/ModalContrFornInfo.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Template/Doc/CompraCotacoesSemPedidoListTable.js",
      "components/Template/Doc/OrcItemsProj.js",
      "components/Template/Doc/PedidosCompraListTable.js",
      "pages/Budget/Dashboard/BudgetDetalhamentoPanel.jsx",
      "pages/Budget/Dashboard/BudgetItemModal.jsx",
      "pages/MeusFornecedores/ContratosTab.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 46,
    "codigo": "CMP-046",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalElaborado",
    "arquivo": "components/Modals/ModalElaborado/ModalElaborado.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/StepStatusProduto/StepStatusProduto.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 47,
    "codigo": "CMP-047",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalErroProdFinalOneDrive",
    "arquivo": "components/Modals/ModalErroProdFinalOneDrive/ModalErroProdFinalOneDrive.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Modals/ModalFormEntregueAoEp/ModalFormEntregueAoEp.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 48,
    "codigo": "CMP-048",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalError",
    "arquivo": "components/Modals/ModalError/ModalError.jsx",
    "kind": "modal",
    "usadoEm": [
      "pages/Dashboard/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dashboard",
        "titulo": "Dashboard"
      }
    ]
  },
  {
    "id": 49,
    "codigo": "CMP-049",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormAddFavBordero",
    "arquivo": "components/Modals/ModalFormAddFavBordero/ModalFormAddFavBordero.jsx",
    "kind": "modal",
    "usadoEm": [
      "pages/Financial/Bordero/DadosFavorecidoPf.js",
      "pages/Financial/Bordero/DadosFavorecidoPj.js",
      "pages/Financial/Bordero/ModalAddContaAPagar.js",
      "pages/Financial/Bordero/ModalEdicaoContaAPagar.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/bordero",
        "titulo": "Borderô"
      },
      {
        "rota": "/dashboardfinancial",
        "titulo": "Dashboard financeiro"
      }
    ]
  },
  {
    "id": 50,
    "codigo": "CMP-050",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormAddFornecedor",
    "arquivo": "components/Modals/ModalFormAddFornecedor/ModalFormAddFornecedor.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx",
      "components/Modals/ModalFormContrFornEventos/ModalFormContrFornEventos.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 51,
    "codigo": "CMP-051",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormAddPjOuPf",
    "arquivo": "components/Modals/ModalFormAddPjOuPf/ModalFormAddPjOuPf.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Modals/ModalFormAddFornecedor/ModalFormAddFornecedor.jsx",
      "components/Modals/ModalFormulario/ModalFormulario.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/pesquisadesatisfacao",
        "titulo": "Pesquisa de satisfação"
      },
      {
        "rota": "/dep-tecnico/projetos",
        "titulo": "Projetos"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 52,
    "codigo": "CMP-052",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormAprovacaoDoCliente",
    "arquivo": "components/Modals/ModalFormAprovacaoDoCliente/ModalFormAprovacaoDoCliente.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/StepStatusProduto/StepStatusProduto.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 53,
    "codigo": "CMP-053",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormAutorizarFaturamento",
    "arquivo": "components/Modals/ModalFormAutorizarFaturamento/ModalFormAutorizarFaturamento.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/StepStatusProduto/StepStatusProduto.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 54,
    "codigo": "CMP-054",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ContrFornValidationEntregaveis",
    "arquivo": "components/Modals/ModalFormContrForn/ContrFornValidationEntregaveis.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 55,
    "codigo": "CMP-055",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ContrFornValidationMinutaPreview",
    "arquivo": "components/Modals/ModalFormContrForn/ContrFornValidationMinutaPreview.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 56,
    "codigo": "CMP-056",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ContrFornValidationStepCadastro",
    "arquivo": "components/Modals/ModalFormContrForn/ContrFornValidationStepCadastro.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 57,
    "codigo": "CMP-057",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormContrForn",
    "arquivo": "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Template/Doc/CompraCotacoesSemPedidoListTable.js",
      "components/Template/Doc/OrcItemsProj.js",
      "components/Template/Doc/PedidosCompraListTable.js",
      "pages/Budget/Dashboard/BudgetCreateContratoModal.jsx",
      "pages/MeusFornecedores/index.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 58,
    "codigo": "CMP-058",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "contrFornCompraCotacaoInfo",
    "arquivo": "components/Modals/ModalFormContrForn/contrFornCompraCotacaoInfo.js",
    "kind": "util",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ContrFornValidationStepCadastro.jsx",
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 59,
    "codigo": "CMP-059",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "contrFornEmailUtils",
    "arquivo": "components/Modals/ModalFormContrForn/contrFornEmailUtils.js",
    "kind": "util",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx",
      "components/Modals/ModalFormContrForn/contrFornMinutaData.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 60,
    "codigo": "CMP-060",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "contrFornEntregaveisUtils",
    "arquivo": "components/Modals/ModalFormContrForn/contrFornEntregaveisUtils.js",
    "kind": "util",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ContrFornValidationEntregaveis.jsx",
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 61,
    "codigo": "CMP-061",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "contrFornExtendedFields",
    "arquivo": "components/Modals/ModalFormContrForn/contrFornExtendedFields.js",
    "kind": "util",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx",
      "components/Modals/ModalFormContrForn/contrFornEmailUtils.js",
      "components/Modals/ModalFormContrForn/contrFornMinutaData.js",
      "components/Modals/ModalFormContrForn/standaloneContrFornSubmit.js",
      "components/Modals/ModalPedidoCompra/ModalPedidoCompra.jsx",
      "components/Modals/ModalPedidoCompra/usePedidoCompraEquipeActions.js",
      "pages/Task/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      },
      {
        "rota": "/task",
        "titulo": "Aprovações (tasks)"
      }
    ]
  },
  {
    "id": 62,
    "codigo": "CMP-062",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "contrFornMinutaData",
    "arquivo": "components/Modals/ModalFormContrForn/contrFornMinutaData.js",
    "kind": "util",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 63,
    "codigo": "CMP-063",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "minutaPlaceholders",
    "arquivo": "components/Modals/ModalFormContrForn/minutaPlaceholders.js",
    "kind": "util",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ContrFornValidationMinutaPreview.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 64,
    "codigo": "CMP-064",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "standaloneContrFornSubmit",
    "arquivo": "components/Modals/ModalFormContrForn/standaloneContrFornSubmit.js",
    "kind": "util",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 65,
    "codigo": "CMP-065",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormContrFornEventos",
    "arquivo": "components/Modals/ModalFormContrFornEventos/ModalFormContrFornEventos.jsx",
    "kind": "modal",
    "usadoEm": [
      "pages/MeusFornecedores/ContratosTab.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 66,
    "codigo": "CMP-066",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormCorrecaoInterna",
    "arquivo": "components/Modals/ModalFormCorrecaoInterna/ModalFormCorrecaoInterna.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/StepStatusProduto/StepStatusProduto.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 67,
    "codigo": "CMP-067",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "DisparoEmailsCotacaoForm",
    "arquivo": "components/Modals/ModalFormDisparoEmails/DisparoEmailsCotacaoForm.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Modals/ModalFormDisparoEmails/ModalFormDisparoEmails.jsx",
      "components/Modals/ModalPedidoCotacao/ModalPedidoCotacao.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 68,
    "codigo": "CMP-068",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormDisparoEmails",
    "arquivo": "components/Modals/ModalFormDisparoEmails/ModalFormDisparoEmails.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Template/Doc/PedidosCompraListTable.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 69,
    "codigo": "CMP-069",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "pedidoCompraEmailTexts",
    "arquivo": "components/Modals/ModalFormDisparoEmails/pedidoCompraEmailTexts.js",
    "kind": "util",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx",
      "components/Modals/ModalFormDisparoEmails/DisparoEmailsCotacaoForm.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 70,
    "codigo": "CMP-070",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormDocumentos",
    "arquivo": "components/Modals/ModalFormDocumentos/ModalFormDocumentos.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Template/Doc/EquiProj.js",
      "components/TesteOneDrive/TesteOneDrive.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 71,
    "codigo": "CMP-071",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormEdicaoFavBordero",
    "arquivo": "components/Modals/ModalFormEdicaoFavBordero/ModalFormEdicaoFavBordero.jsx",
    "kind": "modal",
    "usadoEm": [
      "pages/Financial/Bordero/ModalAddContaAPagar.js",
      "pages/Financial/Bordero/ModalEdicaoContaAPagar.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/bordero",
        "titulo": "Borderô"
      },
      {
        "rota": "/dashboardfinancial",
        "titulo": "Dashboard financeiro"
      }
    ]
  },
  {
    "id": 72,
    "codigo": "CMP-072",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormEditFornecedor",
    "arquivo": "components/Modals/ModalFormEditFornecedor/ModalFormEditFornecedor.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Modals/ModalContrFornInfo/ModalContrFornInfo.jsx",
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx",
      "components/Modals/ModalFormContrFornEventos/ModalFormContrFornEventos.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 73,
    "codigo": "CMP-073",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormEntregueAoCliente",
    "arquivo": "components/Modals/ModalFormEntregueAoCliente/ModalFormEntregueAoCliente.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/StepStatusProduto/StepStatusProduto.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 74,
    "codigo": "CMP-074",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormEntregueAoEp",
    "arquivo": "components/Modals/ModalFormEntregueAoEp/ModalFormEntregueAoEp.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/StepStatusProduto/StepStatusProduto.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 75,
    "codigo": "CMP-075",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormGestaoTecnica",
    "arquivo": "components/Modals/ModalFormGestaoTecnica/ModalFormGestaoTecnica.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/StepStatusProduto/StepStatusProduto.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 76,
    "codigo": "CMP-076",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormOrcItem",
    "arquivo": "components/Modals/ModalFormOrcItem/ModalFormOrcItem.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Template/Doc/OrcItemsProj.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 77,
    "codigo": "CMP-077",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormRevInterna",
    "arquivo": "components/Modals/ModalFormRevInterna/ModalFormRevInterna.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/StepStatusProduto/StepStatusProduto.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 78,
    "codigo": "CMP-078",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormulario",
    "arquivo": "components/Modals/ModalFormulario/ModalFormulario.jsx",
    "kind": "modal",
    "usadoEm": [
      "pages/Comercial/PesquisaDeSatisfacao/PesquisaDeSatisfacao.jsx",
      "pages/TechnicalDep/Project/components/MarketingPesquisaForm.jsx",
      "pages/TechnicalDep/Projects/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/pesquisadesatisfacao",
        "titulo": "Pesquisa de satisfação"
      },
      {
        "rota": "/dep-tecnico/projetos",
        "titulo": "Projetos"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 79,
    "codigo": "CMP-079",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalFormularioSecundario",
    "arquivo": "components/Modals/ModalFormularioSecundario/ModalFormularioSecundario.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Modals/ModalFormulario/ModalFormulario.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/pesquisadesatisfacao",
        "titulo": "Pesquisa de satisfação"
      },
      {
        "rota": "/dep-tecnico/projetos",
        "titulo": "Projetos"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 80,
    "codigo": "CMP-080",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalPedidoCompra",
    "arquivo": "components/Modals/ModalPedidoCompra/ModalPedidoCompra.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Modals/ModalFormDisparoEmails/DisparoEmailsCotacaoForm.jsx",
      "components/Modals/ModalPedidoCotacao/ModalPedidoCotacao.jsx",
      "components/Template/Doc/OrcItemsProj.js",
      "components/Template/Doc/PedidosCompraListTable.js",
      "pages/MeusFornecedores/CotacoesTab.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 81,
    "codigo": "CMP-081",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "usePedidoCompraEquipeActions",
    "arquivo": "components/Modals/ModalPedidoCompra/usePedidoCompraEquipeActions.js",
    "kind": "util",
    "usadoEm": [
      "components/Modals/ModalPedidoCompra/ModalPedidoCompra.jsx",
      "components/Modals/ModalPedidoCotacao/ModalPedidoCotacao.jsx",
      "components/Template/Doc/OrcItemsProj.js",
      "components/Template/Doc/PedidosCompraListTable.js",
      "pages/Task/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      },
      {
        "rota": "/task",
        "titulo": "Aprovações (tasks)"
      }
    ]
  },
  {
    "id": 82,
    "codigo": "CMP-082",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "CotacaoRapidaPropostasSection",
    "arquivo": "components/Modals/ModalPedidoCotacao/CotacaoRapidaPropostasSection.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Modals/ModalPedidoCotacao/IndicacaoCotacaoRapidaForm.jsx",
      "components/Modals/ModalPedidoCotacao/ModalPedidoCotacao.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 83,
    "codigo": "CMP-083",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "IndicacaoCotacaoRapidaForm",
    "arquivo": "components/Modals/ModalPedidoCotacao/IndicacaoCotacaoRapidaForm.jsx",
    "kind": "modal",
    "usadoEm": [
      "pages/Comercial/Acompanhamento/RevisarOrcamento.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      }
    ]
  },
  {
    "id": 84,
    "codigo": "CMP-084",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "ModalPedidoCotacao",
    "arquivo": "components/Modals/ModalPedidoCotacao/ModalPedidoCotacao.jsx",
    "kind": "modal",
    "usadoEm": [
      "components/Template/Doc/OrcItemsProj.js",
      "pages/MeusFornecedores/CotacoesTab.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 85,
    "codigo": "CMP-085",
    "grupoId": "modals-novos",
    "grupo": "Modals (novos)",
    "nome": "cotacaoRapidaFormUtils",
    "arquivo": "components/Modals/ModalPedidoCotacao/cotacaoRapidaFormUtils.js",
    "kind": "util",
    "usadoEm": [
      "components/Modals/ModalPedidoCotacao/CotacaoRapidaPropostasSection.jsx",
      "components/Modals/ModalPedidoCotacao/IndicacaoCotacaoRapidaForm.jsx",
      "components/Modals/ModalPedidoCotacao/ModalPedidoCotacao.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 86,
    "codigo": "CMP-086",
    "grupoId": "modal-legado",
    "grupo": "Modal (legado)",
    "nome": "AddContract",
    "arquivo": "components/Modal/AddContract.js",
    "kind": "modal",
    "usadoEm": [
      "pages/Comercial/Acompanhamento/Acompanhamento.jsx",
      "pages/Comercial/Contracts/index.js",
      "pages/Comercial/Private/index.js",
      "pages/Comercial/Public/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/privado",
        "titulo": "Comercial privado"
      },
      {
        "rota": "/comercial/publico",
        "titulo": "Comercial público"
      }
    ]
  },
  {
    "id": 87,
    "codigo": "CMP-087",
    "grupoId": "modal-legado",
    "grupo": "Modal (legado)",
    "nome": "AddContract2",
    "arquivo": "components/Modal/AddContract2.jsx",
    "kind": "modal",
    "usadoEm": [
      "pages/Comercial/Contracts/Contract/index.js",
      "pages/Comercial/Contracts/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/contratos/:id",
        "titulo": "Contrato"
      }
    ]
  },
  {
    "id": 88,
    "codigo": "CMP-088",
    "grupoId": "modal-legado",
    "grupo": "Modal (legado)",
    "nome": "AddDraftContract",
    "arquivo": "components/Modal/AddDraftContract.js",
    "kind": "modal",
    "usadoEm": [
      "pages/Comercial/Acompanhamento/Acompanhamento.jsx",
      "pages/Comercial/Contracts/index.js",
      "pages/Comercial/Private/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/privado",
        "titulo": "Comercial privado"
      }
    ]
  },
  {
    "id": 89,
    "codigo": "CMP-089",
    "grupoId": "modal-legado",
    "grupo": "Modal (legado)",
    "nome": "DeleteRecordByAdmin",
    "arquivo": "components/Modal/DeleteRecordByAdmin.js",
    "kind": "modal",
    "usadoEm": [
      "pages/Admin/activities.js",
      "pages/Admin/departments.js",
      "pages/Admin/legalPerson.js",
      "pages/Admin/physicalPerson.js",
      "pages/Admin/project.js",
      "pages/Admin/sectors.js",
      "pages/Admin/services.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/admin",
        "titulo": "Admin"
      }
    ]
  },
  {
    "id": 90,
    "codigo": "CMP-090",
    "grupoId": "modal-legado",
    "grupo": "Modal (legado)",
    "nome": "NewLegalEntity",
    "arquivo": "components/Modal/NewLegalEntity.js",
    "kind": "modal",
    "usadoEm": [
      "components/Modal/AddContract.js",
      "components/Modal/AddDraftContract.js",
      "components/Modal/ViewDraftApproval.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/contratos",
        "titulo": "Contratos (cliente)"
      },
      {
        "rota": "/comercial/privado",
        "titulo": "Comercial privado"
      },
      {
        "rota": "/comercial/publico",
        "titulo": "Comercial público"
      }
    ]
  },
  {
    "id": 91,
    "codigo": "CMP-091",
    "grupoId": "modal-legado",
    "grupo": "Modal (legado)",
    "nome": "PdfView",
    "arquivo": "components/Modal/PdfView.js",
    "kind": "modal",
    "usadoEm": [
      "components/Template/Doc/DocTab.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/task",
        "titulo": "Aprovações (tasks)"
      }
    ]
  },
  {
    "id": 92,
    "codigo": "CMP-092",
    "grupoId": "modal-legado",
    "grupo": "Modal (legado)",
    "nome": "PqGridView",
    "arquivo": "components/Modal/PqGridView.js",
    "kind": "modal",
    "usadoEm": [
      "components/Template/Doc/EvePag.js",
      "components/Template/Doc/Extrato.js",
      "components/Template/Doc/Prod.js",
      "components/Template/ProjectFinancialResume/ProjectFinancialResume.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dashboardfinancial",
        "titulo": "Dashboard financeiro"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 93,
    "codigo": "CMP-093",
    "grupoId": "modal-legado",
    "grupo": "Modal (legado)",
    "nome": "ViewDraftApproval",
    "arquivo": "components/Modal/ViewDraftApproval.js",
    "kind": "morto",
    "usadoEm": [],
    "morto": true,
    "apareceEm": []
  },
  {
    "id": 94,
    "codigo": "CMP-094",
    "grupoId": "produto-status",
    "grupo": "Produto / status",
    "nome": "CardInfoProduto",
    "arquivo": "components/CardInfoProduto/CardInfoProduto.jsx",
    "kind": "morto",
    "usadoEm": [],
    "morto": true,
    "apareceEm": []
  },
  {
    "id": 95,
    "codigo": "CMP-095",
    "grupoId": "produto-status",
    "grupo": "Produto / status",
    "nome": "StepStatusProduto",
    "arquivo": "components/StepStatusProduto/StepStatusProduto.jsx",
    "kind": "live",
    "usadoEm": [
      "components/TimelineStatusProduto/TimelineStatusProduto.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 96,
    "codigo": "CMP-096",
    "grupoId": "produto-status",
    "grupo": "Produto / status",
    "nome": "SwiperNavButtons",
    "arquivo": "components/StepStatusProduto/SwiperNavButtons.jsx",
    "kind": "morto",
    "usadoEm": [],
    "morto": true,
    "apareceEm": []
  },
  {
    "id": 97,
    "codigo": "CMP-097",
    "grupoId": "produto-status",
    "grupo": "Produto / status",
    "nome": "StepStatusProdutoSmall",
    "arquivo": "components/StepStatusProdutoSmall/StepStatusProdutoSmall.jsx",
    "kind": "live",
    "usadoEm": [
      "components/TimelineStatusProdutoSmall/TimelineStatusProdutoSmall.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/produtos",
        "titulo": "Produtos"
      }
    ]
  },
  {
    "id": 98,
    "codigo": "CMP-098",
    "grupoId": "produto-status",
    "grupo": "Produto / status",
    "nome": "TimelineStatusProduto",
    "arquivo": "components/TimelineStatusProduto/TimelineStatusProduto.jsx",
    "kind": "live",
    "usadoEm": [
      "components/CardInfoProduto/CardInfoProduto.jsx",
      "components/Template/Doc/Prod.js",
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 99,
    "codigo": "CMP-099",
    "grupoId": "produto-status",
    "grupo": "Produto / status",
    "nome": "TimelineStatusProdutoSmall",
    "arquivo": "components/TimelineStatusProdutoSmall/TimelineStatusProdutoSmall.jsx",
    "kind": "live",
    "usadoEm": [
      "pages/TechnicalDep/Products/DashboardProdutos.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/produtos",
        "titulo": "Produtos"
      }
    ]
  },
  {
    "id": 100,
    "codigo": "CMP-100",
    "grupoId": "graficos",
    "grupo": "Gráficos e tabelas comerciais",
    "nome": "GanttChart",
    "arquivo": "components/GanttChart/GanttChart.jsx",
    "kind": "live",
    "usadoEm": [
      "components/TesteOneDrive/TesteOneDrive.jsx"
    ],
    "morto": false,
    "apareceEm": []
  },
  {
    "id": 101,
    "codigo": "CMP-101",
    "grupoId": "graficos",
    "grupo": "Gráficos e tabelas comerciais",
    "nome": "GridProductsCalendar",
    "arquivo": "components/GridProductsCalendar/GridProductsCalendar.jsx",
    "kind": "live",
    "usadoEm": [
      "components/Template/Doc/Prod.js",
      "components/TesteOneDrive/TesteOneDrive.jsx",
      "pages/TechnicalDep/Products/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/produtos",
        "titulo": "Produtos"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 102,
    "codigo": "CMP-102",
    "grupoId": "graficos",
    "grupo": "Gráficos e tabelas comerciais",
    "nome": "MaterialTable",
    "arquivo": "components/MaterialTable/MaterialTable.jsx",
    "kind": "live",
    "usadoEm": [
      "pages/Dashboard/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dashboard",
        "titulo": "Dashboard"
      }
    ]
  },
  {
    "id": 103,
    "codigo": "CMP-103",
    "grupoId": "graficos",
    "grupo": "Gráficos e tabelas comerciais",
    "nome": "TabelaCruzamentoFluxoMensalPropTemporalEmMeses",
    "arquivo": "components/TabelaCruzamentoFluxoMensalPropTemporalEmMeses/TabelaCruzamentoFluxoMensalPropTemporalEmMeses.jsx",
    "kind": "live",
    "usadoEm": [
      "pages/Comercial/Acompanhamento/RevisarOrcamento.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      }
    ]
  },
  {
    "id": 104,
    "codigo": "CMP-104",
    "grupoId": "graficos",
    "grupo": "Gráficos e tabelas comerciais",
    "nome": "TabelaEspacamentoEventosPagamentoPropTemporalEmMeses",
    "arquivo": "components/TabelaEspacamentoEventosPagamentoPropTemporalEmMeses/TabelaEspacamentoEventosPagamentoPropTemporalEmMeses.jsx",
    "kind": "live",
    "usadoEm": [
      "pages/Comercial/Acompanhamento/RevisarOrcamento.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      }
    ]
  },
  {
    "id": 105,
    "codigo": "CMP-105",
    "grupoId": "graficos",
    "grupo": "Gráficos e tabelas comerciais",
    "nome": "TabelaEspacamentoPropItensTemporalEmMeses",
    "arquivo": "components/TabelaEspacamentoPropItensTemporalEmMeses/TabelaEspacamentoPropItensTemporalEmMeses.jsx",
    "kind": "live",
    "usadoEm": [
      "components/TesteOneDrive/TesteOneDrive.jsx",
      "pages/Comercial/Acompanhamento/RevisarOrcamento.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      }
    ]
  },
  {
    "id": 106,
    "codigo": "CMP-106",
    "grupoId": "graficos",
    "grupo": "Gráficos e tabelas comerciais",
    "nome": "TemporalStackedBarChart",
    "arquivo": "components/TemporalStackedBarChart/TemporalStackedBarChart.jsx",
    "kind": "live",
    "usadoEm": [
      "components/TemporalStackedBarChart/index.js",
      "components/TesteOneDrive/TesteOneDrive.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      }
    ]
  },
  {
    "id": 107,
    "codigo": "CMP-107",
    "grupoId": "graficos",
    "grupo": "Gráficos e tabelas comerciais",
    "nome": "TemporalStackedBarChart",
    "arquivo": "components/TemporalStackedBarChart/index.js",
    "kind": "util",
    "usadoEm": [
      "pages/Comercial/Acompanhamento/RevisarOrcamento.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      }
    ]
  },
  {
    "id": 108,
    "codigo": "CMP-108",
    "grupoId": "outros",
    "grupo": "Outros",
    "nome": "ChatOikosButton",
    "arquivo": "components/ChatOikos/ChatOikosButton.jsx",
    "kind": "live",
    "usadoEm": [
      "components/HorizontalLayout/Navbar.js"
    ],
    "morto": false,
    "apareceEm": []
  },
  {
    "id": 109,
    "codigo": "CMP-109",
    "grupoId": "outros",
    "grupo": "Outros",
    "nome": "ChatOikos",
    "arquivo": "components/ChatOikos/index.jsx",
    "kind": "live",
    "usadoEm": [
      "components/ChatOikos/ChatOikosButton.jsx"
    ],
    "morto": false,
    "apareceEm": []
  },
  {
    "id": 110,
    "codigo": "CMP-110",
    "grupoId": "outros",
    "grupo": "Outros",
    "nome": "DragAndDropTest",
    "arquivo": "components/DragAndDropTest/DragAndDropTest.jsx",
    "kind": "live",
    "usadoEm": [
      "components/TesteOneDrive/TesteOneDrive.jsx"
    ],
    "morto": false,
    "apareceEm": []
  },
  {
    "id": 111,
    "codigo": "CMP-111",
    "grupoId": "outros",
    "grupo": "Outros",
    "nome": "Legenda",
    "arquivo": "components/Legenda/Legenda.jsx",
    "kind": "live",
    "usadoEm": [
      "components/GridProductsCalendar/GridProductsCalendar.jsx",
      "components/Template/Doc/Prod.js",
      "pages/Financial/Receitas/DashboardEPsRec.jsx",
      "pages/Financial/Receitas/index.js",
      "pages/TechnicalDep/Products/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dashboardfinancial",
        "titulo": "Dashboard financeiro"
      },
      {
        "rota": "/dep-tecnico/produtos",
        "titulo": "Produtos"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/receitas",
        "titulo": "Receitas"
      }
    ]
  },
  {
    "id": 112,
    "codigo": "CMP-112",
    "grupoId": "outros",
    "grupo": "Outros",
    "nome": "RecentCertificate",
    "arquivo": "components/RecentCertificate/RecentCertificate.js",
    "kind": "live",
    "usadoEm": [
      "pages/Blockchain/Blockchain.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/blockchain",
        "titulo": "Blockchain / NFT"
      }
    ]
  },
  {
    "id": 113,
    "codigo": "CMP-113",
    "grupoId": "outros",
    "grupo": "Outros",
    "nome": "Subcontratados",
    "arquivo": "components/Subcontratados/Subcontratados.jsx",
    "kind": "morto",
    "usadoEm": [],
    "morto": true,
    "apareceEm": []
  },
  {
    "id": 114,
    "codigo": "CMP-114",
    "grupoId": "outros",
    "grupo": "Outros",
    "nome": "BlurOverlay",
    "arquivo": "components/TestPhaseComponent/BlurOverlay.jsx",
    "kind": "live",
    "usadoEm": [
      "components/Template/ProjectFinancialResume/ProjectFinancialResume.jsx",
      "pages/Comercial/Acompanhamento/RevisarOrcamento.jsx",
      "pages/Dashboard/index.js",
      "pages/TechnicalDep/Project/index.js"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/comercial/acompanhamento",
        "titulo": "Acompanhamento"
      },
      {
        "rota": "/comercial/acompanhamento/revisar-orcamento/:id",
        "titulo": "Revisar orçamento"
      },
      {
        "rota": "/dashboard",
        "titulo": "Dashboard"
      },
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      }
    ]
  },
  {
    "id": 115,
    "codigo": "CMP-115",
    "grupoId": "outros",
    "grupo": "Outros",
    "nome": "ConsoleButton",
    "arquivo": "components/TestPhaseComponent/ConsoleButton.jsx",
    "kind": "live",
    "usadoEm": [
      "components/Modals/ModalFormContrForn/ModalFormContrForn.jsx",
      "components/Modals/ModalPedidoCompra/ModalPedidoCompra.jsx"
    ],
    "morto": false,
    "apareceEm": [
      {
        "rota": "/dep-tecnico/projetos/:id",
        "titulo": "Página do projeto"
      },
      {
        "rota": "/financeiro/orcamento-dashboard",
        "titulo": "Dashboard orçamentário"
      },
      {
        "rota": "/meusfornecedores",
        "titulo": "Gestão de Fornecedores"
      }
    ]
  },
  {
    "id": 116,
    "codigo": "CMP-116",
    "grupoId": "outros",
    "grupo": "Outros",
    "nome": "TesteOneDrive",
    "arquivo": "components/TesteOneDrive/TesteOneDrive.jsx",
    "kind": "live",
    "usadoEm": [
      "App.js"
    ],
    "morto": false,
    "apareceEm": []
  }
]

export const GROUPS = [
  {
    "id": "layout",
    "title": "Layout"
  },
  {
    "id": "common",
    "title": "Common"
  },
  {
    "id": "template-input",
    "title": "Template — Input"
  },
  {
    "id": "template-table",
    "title": "Template — Table"
  },
  {
    "id": "template-files",
    "title": "Template — Files"
  },
  {
    "id": "template-doc",
    "title": "Template — Doc"
  },
  {
    "id": "template-outros",
    "title": "Template — outros"
  },
  {
    "id": "modals-novos",
    "title": "Modals (novos)"
  },
  {
    "id": "modal-legado",
    "title": "Modal (legado)"
  },
  {
    "id": "produto-status",
    "title": "Produto / status"
  },
  {
    "id": "graficos",
    "title": "Gráficos e tabelas comerciais"
  },
  {
    "id": "outros",
    "title": "Outros"
  }
]

export default INVENTORY
